import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import CheckIcon from '@material-ui/icons/Done';
import AddIcon from '@material-ui/icons/Add';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import VirtualList from 'react-tiny-virtual-list';
import AmountField from 'components/QuickenControls/AmountField';
import CategoryField from 'components/QuickenControls/CategoryField';
import zeroStateIcon from 'assets/zero-state-images/safebox.svg';
import ZeroStateView from 'components/ZeroStateView';
import QButton from 'components/QButton';


const styles = (theme) => ({
  VL: {
    padding: '10px 10px',
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      width: 4,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 2,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      WebkitBoxShadow: '0 0 1px rgba(245, 245, 245, 0.5)',
    },
  },
  txnLine: {
    height: 56,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 5,
    padding: 16,
    '&:hover': {
      boxShadow: '1px 1px 3px 0 rgba(0, 0, 0, 0.2)',
      transform: 'translate(0px, 0px)',
    },
  },
  txnLineShaded: {
    extend: 'txnLine',
    backgroundColor: theme.palette.greyScale[5],
  },
  dater: { // 30
    width: 136,
    paddingRight: 16,
  },
  payer: { // 31
    width: '31%',
    minWidth: 90,
    paddingRight: 16,
  },
  typer: { // 28
    width: '28%',
    paddingRight: 16,
  },
  amter: { // 18
    width: '16%',
    textAlign: 'right',
    minWidth: 64,
  },
  checkWrap: {
    height: 22,
    width: 22,
    marginLeft: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  checkIcon: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    color: theme.palette.greyScale[7],
    width: 20,
    height: 20,
    padding: 2,
  },
  selectIcon: {
    borderRadius: '50%',
    border: `1px solid grey`,
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  noCheck: {
    width: 20,
    height: 20,
    padding: 2,
    opacity: 0,
    backgroundColor: 'inherit',
  },
  zeroState: {
    textAlign: 'center',
    lineHeight: 2,
  },
  stateView: {
    height: 360,
    width: '100%',
  },
  zeroRoot: {
    height: '80%',
  },
  zeroReset: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    height: 32,
  },
  resetText: { // TODO Add this to replace #666 somehow...
    color: theme.palette.greyScale[2],
    lineHeight: '32px',
  },
});

class TransactionSelectList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      displayNodes: [],
    };

  }

  checkHighlight(id) {
    const { highlight, multiSelect } = this.props;
    if (multiSelect) {
      return highlight.contains(id)
    }
    return highlight === id;
  }

  generateTxns() {
    const { classes, clickFunc, hideCategory, showSelectIcon } = this.props;
    const acctTxns = this.getAcctTxns();
    this.state.displayNodes = [];
    let i = 0;
    acctTxns.map((txn) => {
      this.state.displayNodes.push(
        <div
          role="presentation"
          key={i}
          name={`txn-item-${i}`}
          id={JSON.stringify(txn)}
          onClick={clickFunc}
          className={this.checkHighlight(txn.id) ? classes.txnLineShaded : classes.txnLine}
        >
          <Typography variant="body2" noWrap className={classes.dater}>
            {moment(txn.postedOn).format('MMM Do, YYYY')}
          </Typography>
          <Typography variant="body2" noWrap className={classes.payer}>
            {txn.payee}
          </Typography>
          {!hideCategory && (
            <CategoryField
              variant="body2"
              classNameWhenNotEditable={classes.typer}
              disableTooltip
              value={txn.coa}
              longCats={false}
              autoFocus={false}
              noWrap
            />
          )}
          <AmountField
            optimisticSign
            color={txn.amount > 0 ? 'green' : undefined}
            value={txn.amount}
            variant="body2"
            className={classes.amter}
            noWrap
          />
          <div className={classes.checkWrap}>
            { this.checkHighlight(txn.id) &&
              <CheckIcon className={classes.checkIcon}/>
            }
            { !this.checkHighlight(txn.id) && showSelectIcon &&
              <AddIcon className={classes.selectIcon}/>
            }
          </div>
        </div>
      );
      i += 1;
      return '';
    });
  }

  getAcctTxns() {
    const { acctTxns, filterByType } = this.props;
    return filterByType ? acctTxns.filter(filterByType) : acctTxns;
  }

  render() {
    const { classes, onReset } = this.props;
    const acctTxns = this.getAcctTxns();

    if (!acctTxns.size) {
      return(
        <div className={classes.stateView}>
          <ZeroStateView
            icon={zeroStateIcon}
            primary="We couldn't find any transactions"
            secondary={
              <>
                You might have searched for something too specific.
                <br/>
                Try resetting the search if so
              </>
            }
            classes={{ secondary: classes.zeroState, root: classes.zeroRoot }}
          />
          <div className={classes.zeroReset}>
            <QButton onClick={onReset} variant="text">
              Click Here
            </QButton>
            <Typography style={{ color: '#666', lineHeight: '32px' }}>
              to reset the search.
            </Typography>
          </div>
        </div>
      );
    }
    if (acctTxns && this.state.displayNodes) {
      this.generateTxns();
    }
    return (
      acctTxns.size &&
        <VirtualList
          height={360}
          itemCount={this.state.displayNodes.length}
          overscanCount={30}
          itemSize={56}
          estimatedItemSize={56}
          renderItem={({ style, index }) => (this.state.displayNodes[index] ?
            <div style={style} key={index}>
              {this.state.displayNodes[index]}
            </div>
            : ''
          )}
          className={this.props.classes.VL}
        />
    );
  }
}

TransactionSelectList.defaultProps = {
  selectorProps: {},
};

TransactionSelectList.propTypes = {
  classes: PropTypes.object.isRequired,
  acctTxns: PropTypes.any,
  clickFunc: PropTypes.func,
  highlight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  hideCategory: PropTypes.bool,
  showSelectIcon: PropTypes.bool,
  multiSelect: PropTypes.bool,
  onReset: PropTypes.func,
  filterByType: PropTypes.func,
  /* eslint-disable react/no-unused-prop-types */
  selectorProps: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  return {
    acctTxns: ownProps.transactionListSelector(state, {
      ...ownProps.selectorProps,
      filter: ownProps.filter,
    }),
  };
}

function mapDispatchToProps() {
  return {};
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(TransactionSelectList);
